import { LifeCycleTypes, useFormSpy } from '@formily/react';

const submitReducer = (state, action) => {
  switch (action.type) {
    case LifeCycleTypes.ON_FORM_SUBMIT_START:
      return { ...state,
        submitting: true
      };

    case LifeCycleTypes.ON_FORM_SUBMIT_END:
      return { ...state,
        submitting: false
      };

    default:
      return state;
  }
};

export const useSubmitState = () => {
  const context = useFormSpy({
    selector: [LifeCycleTypes.ON_FORM_MOUNT, LifeCycleTypes.ON_FORM_SUBMIT_START, LifeCycleTypes.ON_FORM_SUBMIT_END],
    reducer: submitReducer
  });

  if (!context) {
    return null;
  }

  const {
    state,
    form
  } = context;
  return {
    state: state,
    form
  };
};

const validateReducer = (state, action) => {
  switch (action.type) {
    case LifeCycleTypes.ON_FORM_VALIDATE_START:
      return { ...state,
        validating: true
      };

    case LifeCycleTypes.ON_FORM_VALIDATE_END:
      return { ...state,
        validating: false
      };

    default:
      return state;
  }
};

export const useValidateState = () => {
  const {
    state,
    form
  } = useFormSpy({
    selector: [LifeCycleTypes.ON_FORM_MOUNT, LifeCycleTypes.ON_FORM_VALIDATE_START, LifeCycleTypes.ON_FORM_VALIDATE_END],
    reducer: validateReducer
  });
  return {
    state: state,
    form
  };
};
//# sourceMappingURL=es/Other/Submit/hooks.js.map